/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class KnowledgeLibraryServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除知识库
     * @param idList idList
     * @return OK
     */
    deleteKnowledgeLibrary(idList: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-knowledge-library')+ "/knowledge-library";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteKnowledgeLibrary(_response);
        });
    }

    protected processDeleteKnowledgeLibrary(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查看知识库详情
     * @param deviceTypeId (optional) 设备类型ID
     * @param id (optional) 
     * @param issueCode (optional) 问题编号
     * @return OK
     */
    getKnowledgeLibraryDetail(deviceTypeId: string | null | undefined, id: string | null | undefined, issueCode: string | null | undefined): Promise<KnowledgeLibraryDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-knowledge-library')+ "/knowledge-library/detail?";
        if (deviceTypeId !== undefined)
            url_ += "deviceTypeId=" + encodeURIComponent("" + deviceTypeId) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (issueCode !== undefined)
            url_ += "issueCode=" + encodeURIComponent("" + issueCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetKnowledgeLibraryDetail(_response);
        });
    }

    protected processGetKnowledgeLibraryDetail(response: AxiosResponse): Promise<KnowledgeLibraryDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? KnowledgeLibraryDetailVO.fromJS(resultData200) : new KnowledgeLibraryDetailVO();
            return result200;
        }
        return Promise.resolve<KnowledgeLibraryDetailVO>(<any>null);
    }

    /**
     * 导入知识库
     * @param file (optional) file
     * @return OK
     */
    importKnowledgeLibrary(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-knowledge-library')+ "/knowledge-library/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportKnowledgeLibrary(_response);
        });
    }

    protected processImportKnowledgeLibrary(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询知识库
     * @param current (optional) 当前页
     * @param knowledgeLibraryQueryDTO knowledgeLibraryQueryDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageKnowledgeLibrary(current: number | null | undefined, knowledgeLibraryQueryDTO: KnowledgeLibraryQueryDTO, size: number | null | undefined): Promise<IPageOfKnowledgeLibraryVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-knowledge-library')+ "/knowledge-library/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(knowledgeLibraryQueryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageKnowledgeLibrary(_response);
        });
    }

    protected processGetPageKnowledgeLibrary(response: AxiosResponse): Promise<IPageOfKnowledgeLibraryVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfKnowledgeLibraryVO.fromJS(resultData200) : new IPageOfKnowledgeLibraryVO();
            return result200;
        }
        return Promise.resolve<IPageOfKnowledgeLibraryVO>(<any>null);
    }

    /**
     * 新增或修改知识库
     * @param knowledgeLibraryDTO knowledgeLibraryDTO
     * @return OK
     */
    submitKnowledgeLibrary(knowledgeLibraryDTO: KnowledgeLibraryDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/masterlink-cps-knowledge-library')+ "/knowledge-library/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(knowledgeLibraryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmitKnowledgeLibrary(_response);
        });
    }

    protected processSubmitKnowledgeLibrary(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class IPageOfKnowledgeLibraryVO implements IIPageOfKnowledgeLibraryVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: KnowledgeLibraryVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfKnowledgeLibraryVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(KnowledgeLibraryVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfKnowledgeLibraryVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfKnowledgeLibraryVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfKnowledgeLibraryVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: KnowledgeLibraryVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class KnowledgeLibraryDTO implements IKnowledgeLibraryDTO {
    /** 原因 */
    causedBy!: string | undefined;
    /** 设备类型ID */
    deviceTypeId!: string | undefined;
    id!: string | undefined;
    /** 问题编号 */
    issueCode!: string | undefined;
    /** 问题描述 */
    issueDesc!: string | undefined;
    /** 问题等级 */
    issueLevel!: string | undefined;
    /** 问题来源 */
    issueSource!: string | undefined;
    /** 问题类型 */
    issueType!: string | undefined;
    /** 解决方案 */
    solution!: string | undefined;

    constructor(data?: IKnowledgeLibraryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.causedBy = data["causedBy"];
            this.deviceTypeId = data["deviceTypeId"];
            this.id = data["id"];
            this.issueCode = data["issueCode"];
            this.issueDesc = data["issueDesc"];
            this.issueLevel = data["issueLevel"];
            this.issueSource = data["issueSource"];
            this.issueType = data["issueType"];
            this.solution = data["solution"];
        }
    }

    static fromJS(data: any): KnowledgeLibraryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeLibraryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["causedBy"] = this.causedBy;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        data["issueCode"] = this.issueCode;
        data["issueDesc"] = this.issueDesc;
        data["issueLevel"] = this.issueLevel;
        data["issueSource"] = this.issueSource;
        data["issueType"] = this.issueType;
        data["solution"] = this.solution;
        return data; 
    }
}

export interface IKnowledgeLibraryDTO {
    /** 原因 */
    causedBy: string | undefined;
    /** 设备类型ID */
    deviceTypeId: string | undefined;
    id: string | undefined;
    /** 问题编号 */
    issueCode: string | undefined;
    /** 问题描述 */
    issueDesc: string | undefined;
    /** 问题等级 */
    issueLevel: string | undefined;
    /** 问题来源 */
    issueSource: string | undefined;
    /** 问题类型 */
    issueType: string | undefined;
    /** 解决方案 */
    solution: string | undefined;
}

export class KnowledgeLibraryDetailVO implements IKnowledgeLibraryDetailVO {
    /** 原因 */
    causedBy!: string | undefined;
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    id!: string | undefined;
    /** 问题编号 */
    issueCode!: string | undefined;
    /** 问题描述 */
    issueDesc!: string | undefined;
    /** 问题等级 */
    issueLevel!: string | undefined;
    /** 问题来源 */
    issueSource!: string | undefined;
    /** 问题类型 */
    issueType!: string | undefined;
    /** 解决方案 */
    solution!: string | undefined;

    constructor(data?: IKnowledgeLibraryDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.causedBy = data["causedBy"];
            this.deviceTypeId = data["deviceTypeId"];
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.issueCode = data["issueCode"];
            this.issueDesc = data["issueDesc"];
            this.issueLevel = data["issueLevel"];
            this.issueSource = data["issueSource"];
            this.issueType = data["issueType"];
            this.solution = data["solution"];
        }
    }

    static fromJS(data: any): KnowledgeLibraryDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeLibraryDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["causedBy"] = this.causedBy;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["issueCode"] = this.issueCode;
        data["issueDesc"] = this.issueDesc;
        data["issueLevel"] = this.issueLevel;
        data["issueSource"] = this.issueSource;
        data["issueType"] = this.issueType;
        data["solution"] = this.solution;
        return data; 
    }
}

export interface IKnowledgeLibraryDetailVO {
    /** 原因 */
    causedBy: string | undefined;
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    id: string | undefined;
    /** 问题编号 */
    issueCode: string | undefined;
    /** 问题描述 */
    issueDesc: string | undefined;
    /** 问题等级 */
    issueLevel: string | undefined;
    /** 问题来源 */
    issueSource: string | undefined;
    /** 问题类型 */
    issueType: string | undefined;
    /** 解决方案 */
    solution: string | undefined;
}

export class KnowledgeLibraryQueryDTO implements IKnowledgeLibraryQueryDTO {
    /** 设备类型id */
    deviceTypeId!: string | undefined;
    /** 关键词模糊查询 */
    keyValue!: string | undefined;

    constructor(data?: IKnowledgeLibraryQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceTypeId = data["deviceTypeId"];
            this.keyValue = data["keyValue"];
        }
    }

    static fromJS(data: any): KnowledgeLibraryQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeLibraryQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceTypeId"] = this.deviceTypeId;
        data["keyValue"] = this.keyValue;
        return data; 
    }
}

export interface IKnowledgeLibraryQueryDTO {
    /** 设备类型id */
    deviceTypeId: string | undefined;
    /** 关键词模糊查询 */
    keyValue: string | undefined;
}

export class KnowledgeLibraryVO implements IKnowledgeLibraryVO {
    /** 设备类型名称 */
    deviceTypeName!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 问题编号 */
    issueCode!: string | undefined;
    /** 问题类型 */
    issueType!: string | undefined;

    constructor(data?: IKnowledgeLibraryVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceTypeName = data["deviceTypeName"];
            this.id = data["id"];
            this.issueCode = data["issueCode"];
            this.issueType = data["issueType"];
        }
    }

    static fromJS(data: any): KnowledgeLibraryVO {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeLibraryVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceTypeName"] = this.deviceTypeName;
        data["id"] = this.id;
        data["issueCode"] = this.issueCode;
        data["issueType"] = this.issueType;
        return data; 
    }
}

export interface IKnowledgeLibraryVO {
    /** 设备类型名称 */
    deviceTypeName: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 问题编号 */
    issueCode: string | undefined;
    /** 问题类型 */
    issueType: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}